export default function(string) {
  if (typeof string !== 'string') return string;
  return string.replace(/^(\w)/, char => char.toUpperCase());
}
